import { useState } from "react";
import { useStore } from "../../../store";
import { toJS } from "mobx";
import "./index.css";
import MySelect from "../../../components/MySelect";
import TimedButton from "../../../components/Button/TimedButton";
import InputModal, { InputModalProps } from "../../../components/InputModal";
import { useNavigate } from "react-router-dom";

function MenuSettingRegion() {
  const { dataStore } = useStore();
  const resData = toJS(dataStore).resData;
  const navigate = useNavigate();

  const [openDiagnosticModal, setOpenDiagnosticModalModal] = useState<InputModalProps & { key?: any }>({
    isOpen: false,
    title: "Password:",
    password: true,
    onSave: (value: string) => {
      if (value === '8888') {
        if (resData.activeLogAck?.state === 'DRAFT') {
          navigate("/");
          dataStore.sendData({
            action: 'openDiagnostic',
            data: {
              password: value
            },
          })
        }
      }
      setOpenDiagnosticModalModal((data) => ({ ...data, isOpen: false, key: Date.now() }));
    },
    onCancel: () => {
      setOpenDiagnosticModalModal((data) => ({ ...data, isOpen: false }));
    },
  });

  const onChangeTemperatureUnit = (value: string) => {
    dataStore.sendData({
      action: 'updateSetting',
      data: {
        key: 'temperatureUnit', value
      }
    })
  }


  const onChangeDateFormat = (value: string) => {
    dataStore.sendData({
      action: 'updateSetting',
      data: {
        key: 'dateFormat', value
      }
    })
  }



  const langOptions = [
    { value: 'en', label: 'English' },
  ]

  const dateFormatOptions = [
    { value: 'DD.MM.YYYY', label: 'DD.MM.YYYY' },
    { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY' },
    { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD' },
  ]




  return (
    <div className="w-4/6 relative mr-10">

      <InputModal {...openDiagnosticModal} />




      <div className="border-2 rounded-2xl absolute inset-0 m-auto h-4/6 opacity-1 mr-10"
        style={{
          backgroundColor: 'rgba(212,115,0,0.5)',
          boxShadow: "8px 8px 8px  rgba(0, 0, 0, 0.3)",
        }}
      >
        <TimedButton
          style={{
            // backgroundColor: 'red',
            height: 100,
            width: 100,
            position: 'absolute',
            bottom: 0,
          }}
          handleTenClicks={() => {
            setOpenDiagnosticModalModal((data) => ({ ...data, isOpen: true, value: '', }))
          }}
        />

        <div className="h-[500px] overflow-auto m-10">
          <div className="h-12 px-28">
            <span className="float-left text-white text-3xl mt-1">
              Language
            </span>

            <MySelect
              value={langOptions[0]}
              options={langOptions}
              className="w-[180px] float-right mt-[1px]"
            // onChange={e => onChangeDateFormat(e.value)}
            />

          </div>
          <br></br>
          <div className="h-12 px-28">
            <span className="float-left text-white text-3xl mt-1">
              Date Format
            </span>

            <MySelect
              value={dateFormatOptions.find(item => item.value === resData.loadSettingAck?.dateFormat) || dateFormatOptions[0]}
              options={dateFormatOptions}
              className="w-[180px] float-right mt-[1px]"
              onChange={e => onChangeDateFormat(e.value)}
            />

          </div>
          <br></br>

          <div className="h-12 px-28">
            <span className="float-left text-white text-3xl mt-1">
              Temperature Unit
            </span>

            <div

              style={{
                borderWidth: 1.5,
                borderColor: 'white',
              }}
              className="region-content-right-div w-50">
              <span
                className="mr-3 px-1"
                style={{
                  color: resData.loadSettingAck?.temperatureUnit === "C" ? "#ffffff" : "#a9a7a7",
                }}
                onClick={() => onChangeTemperatureUnit("C")}
              >
                ℃
              </span>
              <span
                className="px-2"
                style={{
                  color: resData.loadSettingAck?.temperatureUnit === "F" ? "#ffffff" : "#a9a7a7",
                }}
                onClick={() => onChangeTemperatureUnit("F")}
              >
                ℉
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default MenuSettingRegion;
